import React from "react";
import Button from "react-bootstrap/Button";
import { MDBDataTable } from "mdbreact";
import * as misConstantes from "../../../../../js/constantes.js";
import InicioBreadcrumbs from "../../../../../pages/template/breadcrumbs/InicioBreadcrumbs.js";

import { Link } from "react-router-dom";

import axios from "axios";
import { cleanText } from "../../../../../js/util.js";

class CotizacionProveedor extends React.Component {
  constructor(props) {
    super(props);
    var url = window.location.href;
    var data = url.split("/");

    var idSimulacion = data[data.length - 3];
    var idProveedor = data[data.length - 2];
    var nombreProveedor = data[data.length - 1];
    nombreProveedor = cleanText(nombreProveedor);
    console.log(data);
    console.log(idSimulacion, idProveedor, nombreProveedor);
    var columnas = [
      {
        field: "articulo",
        label: "Articulos",
        attributes: { width: "40%" },
      },

      {
        field: "precioBase",
        label: "Precio Base Sin Impuestos",
        attributes: { width: "20%" },
      },
      {
        field: "precioTechoProveedor",
        label: "Precio Techo Proveedor Sin Impuestos",
        attributes: { width: "20%" },
      },
      {
        field: "precioOfertado",
        label: "Precio Ofertado Con Impuestos",
        attributes: { width: "20%" },
      },
    ];

    this.state = {
      datos: { columns: columnas, rows: [] },
      columnas: columnas,
      idSimulacion: idSimulacion,
      idProveedor: idProveedor,
      nombreProveedor: nombreProveedor,
      mensajeCarga: "Cargando...",
    };
  }
  componentDidMount() {
    this.detalleProveedor();
  }

  render() {
    return (
      <>
        <div
          class="menu"
          style={{
            backgroundColor: "#dbe7fc",
            width: "100%",
            padding: "10px",
            fontSize: "12px",
          }}
        >
          <div class="container">
            <InicioBreadcrumbs></InicioBreadcrumbs> /{" "}
            <Link to="/simulaciones">Simulaciones</Link> / Simulacion:{" "}
            <Link to={this.state.linkSimulacion}>
              {" "}
              {this.state.nombreSimulacion}{" "}
            </Link>{" "}
            / {this.state.nombreProveedor}
          </div>
        </div>

        <div
          class="container"
          style={{ minHeight: "550px", paddingTop: "30px" }}
        >
          <div class="subitulosPaginaNotificaciones">
            <b>
              Proveedor: {this.state.nombreSimulacion}:{" "}
              {this.state.nombreProveedor}
            </b>
          </div>
          <br />

          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
              style={{ display: this.state.mostrarBotonesAbiertos }}
            >
              <Button
                variant="primary"
                style={{ width: "100%" }}
                onClick={this.handleIrASimulacion.bind(this)}
              >
                <i class="fas fa-chevron-circle-left"></i> Volver a simulación
              </Button>
            </div>
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
              style={{ display: this.state.mostrarBotonesAbiertos }}
            ></div>
          </div>
          <br />
          <div class="fila">
            <div
              class="col-lg-6 col-md-6 col-sm-12 mr-auto"
              style={{ paddingLeft: "10px !important" }}
            ></div>
          </div>

          <br />

          <div style={{ whiteSpace: "pre-wrap" }}>
            {this.state.mensajeCarga}
            <MDBDataTable
              striped
              bordered
              small
              data={this.state.datos}
              hover
              entriesOptions={[5, 10, 15, 25]}
              entries={15}
              pagesAmount={4}
              condensed
            />
          </div>
          <br />
        </div>
      </>
    );
  }

  // ------------------------------------------------------------------------------------------------------
  // ItemSimulacionProveedor
  // ------------------------------------------------------------------------------------------------------
  handleIrASimulacion(event) {
    window.location.href = "/simulacion/" + this.state.idSimulacion;
  }
  // ------------------------------------------------------------------------------------------------------
  // PreciosTodosProveedor
  // ------------------------------------------------------------------------------------------------------
  detalleProveedor() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idSimulacion = this.state.idSimulacion;
    var idProveedor = this.state.idProveedor;

    var info = {
      codigo: codigo,
      idSimulacion: idSimulacion,
      idProveedor: idProveedor,
    };
    console.log(info);
    this.setState({ mensajeTabla: "Cargando" });
    axios
      .post(misConstantes.URL_CONSULTA + "/ServletPreciosItemProveedor", info, {
        params: info,
      })
      .then(
        function (response) {
          this.setState({ mensajeTabla: "" });
          // alert( JSON.stringify( response.data )  );
          console.log(response.data);
          var items = response.data;
          var rows = [];
          for (var i = 0; i < items.length; i++) {
            console.log(items[i]);
            var row = {
              articulo: items[i].producto.nombreProducto,
              precioBase: items[i].producto.precioItemBase,
              precioTechoProveedor: items[i].producto.precioItemTechoProveedor,
              precioOfertado: items[i].producto.precioItemOfertado,
            };
            rows.push(row);
          }

          var columns = this.state.columnas;
          console.log(columns);
          var datos = { columns: columns, rows: rows };
          this.setState({ datos: datos, mensajeCarga: "" });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  //
}

export default CotizacionProveedor;
